import { useEffect, useRef } from "react";
import * as echarts from "echarts";

/**
 * Envoltório do ECharts.
 *
 * O ECharts vive fora do React: ele desenha em canvas e guarda estado próprio.
 * Três coisas precisam ser feitas à mão, e as três são fonte clássica de bug:
 *
 *  - **Descartar na desmontagem.** Sem `dispose`, cada troca de período deixa
 *    para trás uma instância com listener de resize. Depois de uma tarde de uso
 *    a aba fica pesada e ninguém liga uma coisa à outra.
 *  - **Reagir ao tamanho, não à janela.** O painel tem colunas que mudam de
 *    largura sem a janela mudar. `ResizeObserver` no contêiner pega isso;
 *    `window.onresize` não.
 *  - **`notMerge` ao trocar a opção.** Sem isso, uma série antiga com mais
 *    pontos que a nova sobrevive por baixo — o gráfico mostra dezembro de um
 *    período que o usuário já trocou.
 */
export function Grafico({ opcao, altura = 280 }: { opcao: unknown; altura?: number }) {
  const alvo = useRef<HTMLDivElement>(null);
  const grafico = useRef<echarts.ECharts | null>(null);

  useEffect(() => {
    if (!alvo.current) return undefined;
    grafico.current = echarts.init(alvo.current, undefined, { renderer: "canvas" });
    const observador = new ResizeObserver(() => grafico.current?.resize());
    observador.observe(alvo.current);
    return () => {
      observador.disconnect();
      grafico.current?.dispose();
      grafico.current = null;
    };
  }, []);

  useEffect(() => {
    grafico.current?.setOption(opcao as echarts.EChartsOption, { notMerge: true });
  }, [opcao]);

  return <div ref={alvo} style={{ height: altura, width: "100%" }} />;
}
